"use client"

import { createContext, useState, useContext } from "react"

const CartContext = createContext()

export const useCart = () => useContext(CartContext)

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([])

  const addItem = (item) => {
    setCartItems([...cartItems, item])
  }

  const removeItem = (itemId) => {
    setCartItems(cartItems.filter((item) => item.id !== itemId))
  }

  const clearCart = () => {
    setCartItems([])
  }

  const isInCart = (itemId) => {
    return cartItems.some((item) => item.id === itemId)
  }

  return (
    <CartContext.Provider value={{ cartItems, addItem, removeItem, clearCart, isInCart }}>
      {children}
    </CartContext.Provider>
  )
}

